export const categories = [
  {
    id: 'jichu-rumen',
    name: '基础入门',
    description: '从零开始了解亲密发声的基本概念、身心准备与核心原则，为深入学习打下坚实基础。',
    icon: 'ri-book-open-line',
    imageSeq: 'cat-basic',
  },
  {
    id: 'jinjie-jiqiao',
    name: '进阶技巧',
    description: '探索更丰富的声音表达方式，掌握节奏、音色、层次感等高级发声技巧。',
    icon: 'ri-star-line',
    imageSeq: 'cat-advanced',
  },
  {
    id: 'xinli-tansuo',
    name: '心理探索',
    description: '深入理解发声背后的心理机制，克服羞耻感，实现真正的自我接纳与情感释放。',
    icon: 'ri-heart-line',
    imageSeq: 'cat-psychology',
  },
  {
    id: 'banlv-goutong',
    name: '伴侣沟通',
    description: '学习如何与伴侣建立开放、坦诚的沟通渠道，让声音成为增进亲密关系的桥梁。',
    icon: 'ri-chat-heart-line',
    imageSeq: 'cat-communication',
  },
  {
    id: 'shenxin-jiankang',
    name: '身心健康',
    description: '关注亲密发声对身心健康的积极影响，包括盆底肌锻炼、压力释放与情绪管理。',
    icon: 'ri-mental-health-line',
    imageSeq: 'cat-health',
  },
];